import getPieveToolCallDisplayText from '@/lib/platform/getPieveToolCallDisplayText.js';

/**
 * Turns the events of one automation run's conversation into what the run history shows: each action Pieve
 * took in plain words with whether it worked, and the run's result (Pieve's last answer). Events may arrive
 * in any order; they are read by sequence number.
 */
const buildRunStepsFromEvents = (events = []) => {
  const ordered = [...events].sort((left, right) => left.seq - right.seq);
  const resultByCallId = new Map(ordered.filter((event) => event.type === 'tool_result').map((event) => [event.payload?.callId, event.payload]));
  const steps = ordered
    .filter((event) => event.type === 'tool_call')
    .map((event) => {
      const result = resultByCallId.get(event.payload?.callId);
      const failed = result?.output?.success === false;

      return {
        id: event.eventId,
        label: event.payload?.displayText || getPieveToolCallDisplayText({ toolName: event.payload?.toolName, args: event.payload?.args }),
        state: !result ? 'running' : failed ? 'failed' : 'done',
        error: failed ? result.output?.data?.message || result.result?.message || null : null
      };
    });
  const answers = ordered.filter((event) => event.type === 'message' && event.payload?.role === 'assistant' && event.payload?.text);

  return { steps, result: answers.length > 0 ? answers[answers.length - 1].payload.text : null };
};

export default buildRunStepsFromEvents;
